import { effect, signal } from '@preact/signals';

import { capacitorBridge, nativeTapDriver } from '@amumin/platform/capacitor';
import { installTapFeedback, setHapticsEnabled, setTapDriver } from '@amumin/ui-core';

import { context } from './session.js';

// Trillen bij tikken (oprichter 1 okt 2026): een korte trilling op een Android-telefoon als je een
// knop indrukt. Per gebruiker in deze browser (localStorage), standaard aan; alleen "uit" wordt
// bewaard. In iOS Safari of op een computer doet het niets (geen navigator.vibrate); in de
// iPhone-app (apps/mobile) trilt de Taptic Engine via Capacitor Haptics.

const key = (): string => `fb.haptics.${context.value?.identity.id ?? 'anon'}`;

function read(k: string): boolean {
  try {
    return window.localStorage.getItem(k) !== '0';
  } catch {
    return true;
  }
}

/** De keuze van de ingelogde gebruiker (Instellingen · Jouw account). */
export const hapticsOn = signal(true);

export function setHaptics(on: boolean): void {
  hapticsOn.value = on;
  try {
    if (on) window.localStorage.removeItem(key());
    else window.localStorage.setItem(key(), '0');
  } catch {
    // Geen opslag (privévenster): de keuze geldt tot herladen.
  }
}

/** Eén luisteraar voor de hele app, en de keuze volgen bij wisselen van gebruiker. */
export function installWebHaptics(): () => void {
  // iPhone-app: native trillen in plaats van navigator.vibrate (bestaat niet in iOS).
  const bridge = capacitorBridge();
  if (bridge) setTapDriver(nativeTapDriver(bridge));
  const off = installTapFeedback();
  const stop = effect(() => {
    hapticsOn.value = read(key());
  });
  const sync = effect(() => setHapticsEnabled(hapticsOn.value));
  return () => {
    off();
    if (bridge) setTapDriver(null);
    stop();
    sync();
  };
}
